"use client";
import React from "react";
import { FaEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import FaqPane from "./faq-pane";

//
export default function AlFaq({ page }: { page: any }) {
  const [faqs, setFaq] = React.useState<any>(page);

  const togView = (index: number, state: any) => {
    const mutd: any[] = [...faqs];
    mutd[index]["is_togged"] = !mutd[index]["is_togged"];
    setFaq(mutd);
  };

  const launchAdd = () => {};
  return (
    <React.Fragment>
      <div className="flex flex-row border-bottom align-items-center px20 py10">
        <span className="spacer align-items-center justify-content-center">
          -
        </span>
        <span className="group-btn">
          <Link to="/admin/faq/new">
            <FaEdit /> <span className="sm-hide px5">ADD NEW</span>
          </Link>
        </span>
      </div>

      <div className="dashboard-page-content">
        <FaqPane data={faqs} />
      </div>
    </React.Fragment>
  );
}
